import { Box, Text, VStack, Checkbox, Badge } from '@chakra-ui/react';
import { Scrollbars } from 'react-custom-scrollbars-2';

import {
  renderThumb,
  renderTrack,
  renderView,
} from 'components/scrollbar/Scrollbar';

interface ValidationColumnProps {
  validations: Validation[];
  selectedValidations: string[];
  onToggle: (id: string) => void;
}

const ValidationColumn = ({
  validations,
  selectedValidations,
  onToggle,
}: ValidationColumnProps) => {
  return (
    <Box flex="1" w={{ base: '100%', lg: 'auto' }}>
      <Text fontWeight="bold" fontSize="lg" mb={3}>
        Validations
      </Text>
      <Box h={{ base: '200px', lg: '300px' }}>
        <Scrollbars
          autoHide
          renderTrackVertical={renderTrack}
          renderThumbVertical={renderThumb}
          renderView={renderView}
        >
          <VStack align="stretch" spacing={2} width="100%" pl={2} pb={8}>
            {validations.length === 0 ? (
              <Text color="gray.500" fontSize="sm">
                No cautioned or failed validations
              </Text>
            ) : (
              validations.map((validation) => (
                <Checkbox
                  key={validation.validation_id}
                  isChecked={selectedValidations.includes(
                    validation.validation_id,
                  )}
                  onChange={() => onToggle(validation.validation_id)}
                >
                  <Text fontSize="sm">{validation.validation_name}</Text>
                  <Badge
                    colorScheme={
                      validation.validation_outcome === 'fail'
                        ? 'red'
                        : 'yellow'
                    }
                    p={1}
                    size="sm"
                  >
                    <Text fontSize={10}>
                      {validation.validation_outcome === 'fail'
                        ? 'Fail'
                        : 'Caution'}
                    </Text>
                  </Badge>
                </Checkbox>
              ))
            )}
          </VStack>
        </Scrollbars>
      </Box>
    </Box>
  );
};

export default ValidationColumn;
